// extracted by mini-css-extract-plugin
export default {"loaderContainer":"ChangeLog_loaderContainer__ZMQQq","loader":"ChangeLog_loader__O4nRB"};